import React from "react";

import Waypoint from "react-waypoint";
import { withState } from "recompose";

export default withState(
  "status",
  "onVisibleChange",
  "hidden"
)(({ status, onVisibleChange, children, style }) =>
  <Waypoint
    onEnter={() => onVisibleChange("visible")}
    onLeave={() => onVisibleChange("left")}
    topOffset={0}
    bottomOffset={150}
    scrollableAncestor={"window"}
  >
    <div
      style={{
        transition: "opacity 800ms ease-out,transform 400ms ease-out",
        transform: `translate3d(0px,${status !== "hidden" ? 0 : 20}px,0px)`,
        opacity: status === "visible" ? 1 : 0,
        width: "100%",
        ...style
      }}
    >
      {children}
    </div>
  </Waypoint>
);



// WEBPACK FOOTER //
// ./src/components/atoms/FadeIn.js